import { Col, message, Row } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  FormItem,
  ButtonItem,
  ErrorItem,
  Form,
  InputNumberItem,
} from "../../../../Components/Items";
import ModalConteoEfectivo from "../../../PuntoDeVenta/CorteCaja/ModalConteoEfectivo/ModalConteoEfectivo";

class AbrirCaja extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    todasBancos: [],
    modalConteoVisible: false,
    totalContado: 0,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      // Resetear estado cuando se abre/cierra el modal principal
      if (this.props.visible) {
        this.setState({ modalConteoVisible: false });
        if (this.formRef.current) {
          if (this.props.saldoInicial) {
            this.formRef.current.setFieldsValue({
              capitalInicial: this.props.saldoInicial,
            });
          } else {
            this.formRef.current.setFieldsValue({
              capitalInicial: 0,
            });
          }
        }
      }

    }
  }


  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    let datos = {
      empresaId: this.props.empresaId,
      saldoInicial: values.capitalInicial,
      usuarioId: this.props.headersToken.usuarioId,
      cajaId: this.props.cajaId,
    };

    axios
      .post(
        "sesionesPV/agregarSesionPV",
        { datos: datos },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const relativeUrl = `/puntoDeVenta/${res.data.sesionId}`;
          const fullUrl = window.location.origin + relativeUrl;
          window.open(fullUrl, '_blank');
          this.props.cerrarAbrirCaja();
        } else if (res.data.success === 1) {
          // Manejar otro caso de éxito si es necesario
        } else {
          message.error("Error");
        }
      })
      .catch((error) => {
        console.error("Error al abrir caja:", error);
        message.error("Error al abrir la caja");
      });

    this.setState({ cajaId: false, loading: false });
  }

  cerrarAbrirCaja = () => {
    this.props.cerrarAbrirCaja();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    // Cerrar también el modal de conteo si está abierto
    this.setState({
      modalConteoVisible: false
    });
  };

  // Abrir modal de conteo de efectivo
  abrirModalConteo = () => {
    this.setState({
      modalConteoVisible: true
    });
  };

  // Obtener el valor actual del formulario
  obtenerValorFormulario = () => {
    if (this.formRef.current) {
      return this.formRef.current.getFieldValue('capitalInicial') || 0;
    }
    return 0;
  };

  // Manejar confirmación del conteo
  handleConteoConfirmado = (totalContado) => {

    // Actualizar el campo del formulario con el total contado
    if (this.formRef.current) {
      this.formRef.current.setFieldsValue({
        capitalInicial: totalContado
      });

      // Forzar re-render y validación
      this.formRef.current.validateFields(['capitalInicial']).catch(() => {
        // Manejar errores de validación si es necesario
        console.error('Error de validación al actualizar capitalInicial');
      });
    }

    // Cerrar el modal de conteo
    this.setState({
      modalConteoVisible: false
    });

    message.success(`Capital inicial actualizado: $${totalContado.toFixed(2)}`);
  };

  // Manejar cancelación del conteo
  handleConteoCancel = () => {
    this.setState({ modalConteoVisible: false });
  };

  render() {
    return (
      <>
        <ModalItem
          title="Agregar Caja"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarAbrirCaja.bind(this)}
        >
          <Form
            ref={this.formRef}
            name="modalAbrirCaja"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
                loading={this.state.loading}
              >
                Abrir Caja
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Row>
              <Col span={18}>
                <FormItem
                  name="capitalInicial"
                  label="Capital Inicial"
                  required
                  margin
                  number
                >
                  <InputNumberItem
                    disabled={this.props.saldoInicial !== 0}
                    placeholder="Ingresa el capital inicial"
                    style={{ width: "100%" }}
                    precision={2}
                    min={0}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <ButtonItem
                  type="default"
                  onClick={this.abrirModalConteo}
                  style={{
                    minWidth: '120px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '4px'
                  }}
                  disabled={this.props.saldoInicial !== 0}
                >
                  💰 Contar
                </ButtonItem>
              </Col>
            </Row>
          </Form>
        </ModalItem>

        {/* Modal de Conteo de Efectivo */}
        <ModalConteoEfectivo
          visible={this.state.modalConteoVisible}
          valorInicial={this.obtenerValorFormulario()}
          onConfirmar={this.handleConteoConfirmado}
          onCancel={this.handleConteoCancel}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AbrirCaja);